import { css } from '@emotion/react';

import { fluid, fonts } from '../../style-tokens';

const base = css`
  font-family: ${fonts.sans.family};
  margin-bottom: 0;
  margin-top: 0;
`;

export const h1 = css`
  ${base}

  font-size: ${fluid(2.65, 5.05)};
  font-weight: 700;
  hyphens: auto;
  letter-spacing: ${fluid(0.02, 0.115)};
  line-height: 1.058;
  margin-right: ${fluid(4, 5.5)};
  text-align: right;
  text-transform: uppercase;
`;

export const h2 = css`
  ${base}

  font-size: ${fluid(1.3, 1.55)};
  font-weight: 500;

  @media (min-width: 2300px) {
    font-size: ${fluid(2, 2.85)};
  }
`;

export const h3 = css`
  ${base}

  font-size: ${fluid(1.07, 1.2)};
  line-height: 1.3;

  @media (min-width: 2300px) {
    font-size: ${fluid(1.55, 1.85)};
  }
`;

export const h4 = css`
  ${base}

  font-size: ${fluid(1.5, 1.575)};
  font-weight: 500;
  letter-spacing: ${fluid(0.02, 0.035)};
`;

export const heavy = css`
  font-weight: 700;
`;
